exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".products-by-customer-link-panel{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px}.products-by-customer-link-panel header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.products-by-customer-link-panel .title{font-size:1.8rem;line-height:2rem;margin-bottom:10px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/products-by-customer-link-panel/index.scss
// module id = 5155
// module chunks = 0